


























































































import { Component, Vue } from "vue-property-decorator";
import vueSeamlessScroll from "vue-seamless-scroll";
import { getRankTop } from "@/req/homes";
@Component({
  components: { vueSeamlessScroll },
})
export default class Home extends Vue {
  public listDataOne = [
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200442/6572d3a2d1b4e.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9979/653f2407b8253.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9993/654606e6a790c.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200586/65603e6863017.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/201005/6566a0fa2f9b2.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9191/64ddd07291019.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/7904/6458a80c211b1.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10341/64c7a7eaab1fd.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10155/63ee11dce4229.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10454/657fd51b473c3.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10421/6556c3167a699.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10393/65372b30bcc1a.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10346/6567fb1eaa9ce.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10172/63db76fd123f5.jpg",
    },
  ];
  public listDataTwo = [
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200597/656edb7a0a7ba.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200081/6549a7b9ed757.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9678/65853f2d612f6.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/3809/62f494c8cb378.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/4706/645a19341606a.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200522/654dfdd4ecc9a.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/8684/64b64be3ad559.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9750/65238ab87f9bb.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/8860/64d19e7369e93.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200429/655178ad07885.jpg",
    },
    // {
    //   src:
    //     "https://static.dhsf.996box.com/box/ranklogo/8838/64ace74b5098b.jpg",
    // },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/1062/648fb5ee3d0de.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9928/65320b5fa6258.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/4561/63635e3924348.jpg",
    },
  ];
  public listDataThree = [
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10205/641af87a002d8.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10378/654d9eafae97d.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10402/6538dfb48b4cc.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10429/6569ab79363fe.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10271/6477005ce27cc.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10216/649e62cc4f011.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10396/652cd1397f8ac.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10150/63a550f37ba07.jpg",
    },
    // {
    //   src:
    //     "https://static.dhsf.996box.com/box/ranklogo/10430/6567ed2f4d170.jpg",
    // },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10174/641c47fe0220c.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10437/6577f946dc4b9.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10417/6577ea8497a31.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10352/64f03d8422002.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10307/64993d8e91978.jpg",
    },
  ];
  public listDataFour = [
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10262/6455e4bc0c36d.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10359/64e6b785b2815.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10386/6522640fe861f.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10337/6538d78b8a7ac.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10121/63c64c7e0d165.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10370/6507c344aaff8.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10419/655abb7841140.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10306/64b8e796a87bd.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10420/655f0e3105d08.png",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10382/65716ec7944ec.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10409/65701a651a82b.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10304/657823d47b0f0.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10354/652cb2448805d.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/10161/63c274d53fbcc.jpg",
    },
  ];
  public listDataFive = [
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/6305/6524a7b7c450d.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/5118/65800f3f6d34b.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/7463/656098b83e353.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200403/653f196faaecf.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/4328/634cf79490c7e.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/2912/631c5c5bcd653.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200243/65485a16c9b9e.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200379/656039867b0f7.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/3455/65645b3c1d9c6.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/2180/6584ec5334fd9.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/9565/650a9c393d074.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200420/656400da5aa2e.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/200104/6537b0269ec4c.jpg",
    },
    {
      src: "https://static.dhsf.996box.com/box/ranklogo/5114/652cec4cc1261.jpg",
    },
  ];
  public optionData = {
    step: 1, // 数值越大速度滚动越快
    limitMoveNum: 20, // 开始无缝滚动的数据量 this.dataList.length
    hoverStop: true, // 是否开启鼠标悬停stop
    direction: 3, // 0向下 1向上 2向左 3向右
    openWatch: true, // 开启数据实时监控刷新dom
    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
    waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
  };
  public created() {
    this.getList();
  }
  public async getList() {
    const res = await getRankTop({});
    if (res.code == 200) {
      this.listDataOne = res.data.slice(0, 20);
      this.listDataTwo = res.data.slice(20, 40);
      this.listDataThree = res.data.slice(40, 60);
      this.listDataFour = res.data.slice(60, 80);
      this.listDataFive = res.data.splice(80, 100);
    } else {
      this.$Message.error(res.msg);
    }
  }
  public toDetail(e) {
    const data = JSON.parse(e.target.dataset.obj);
  }
  public bannerMouseover() {
    this.optionData.step = 0;
  }
  public bannerMouseleave() {
    this.optionData.step = 1;
  }
}
